'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTreatment = buildTreatment;
exports.buildParameter = buildParameter;
exports.buildTreatmentRequest = buildTreatmentRequest;
exports.buildBulkTreatmentRequest = buildBulkTreatmentRequest;
exports.buildExposureLogRequest = buildExposureLogRequest;
exports.buildBulkExposureLogRequest = buildBulkExposureLogRequest;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _isProd = _enviro2.default.isProd();
var _suffix = _isProd ? '' : 'qa';
var _host = 'https://api.hubspot' + _suffix + '.com';

function buildRequest() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'GET';
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var url = _host + '/' + pathname;
  if (pathname[0] === '/') {
    url = '' + _host + pathname;
  }
  return {
    method: method,
    url: url,
    body: body
  };
}

function buildTreatment() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var identifierOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var isMocked = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  return {
    key: key,
    identifier: identifierOverride || '' + _hubspot2.default.get(),
    parameters: parameters || [],
    isMocked: isMocked
  };
}

function buildParameter() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isAssigned = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isMocked = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  return {
    key: key,
    value: value,
    isAssigned: !!(value && isAssigned),
    isMocked: isMocked
  };
}

function buildTreatmentRequest() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var identifierOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var identifier = identifierOverride || '' + _hubspot2.default.get();
  var method = 'GET';
  var pathname = 'treatments/v1/get/' + key + '/' + identifier;
  var body = {
    key: key,
    identifier: identifier
  };
  return buildRequest(method, pathname, body);
}

function buildBulkTreatmentRequest() {
  var requests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var method = 'POST';
  var pathname = 'treatments/v1/bulk-get';
  var body = [];
  requests.forEach(function (request) {
    body.push({
      key: request.body.key,
      identifier: request.body.identifier || '' + _hubspot2.default.get()
    });
  });
  return buildRequest(method, pathname, body);
}

function buildExposureLogRequest() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var identifierOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var method = 'POST';
  var pathname = 'treatments/v2/exposure/log';
  var body = {
    key: key,
    identifier: identifierOverride || '' + _hubspot2.default.get()
  };
  return buildRequest(method, pathname, body);
}

function buildBulkExposureLogRequest() {
  var requests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var method = 'POST';
  var pathname = 'treatments/v2/exposure/log-bulk';
  var body = [];
  requests.forEach(function (request) {
    body.push({
      key: request.body.key,
      identifier: request.body.identifier || '' + _hubspot2.default.get()
    });
  });
  return buildRequest(method, pathname, body);
}